import { NgModule } from "@angular/core";
import { StagesCommonModule } from "common/common.module";
import { UserSettingsComponent } from "user/settings/user-settings.component";
import { UserRoutingModule } from "user/user-routing.module";
import { UserComponent } from "user/user.component";
import { SudoDialogComponent } from "user/sudo/sudo-dialog.component";
import { OtpDialogComponent } from "user/otp/otp-dialog.component";
import { QRCodeModule } from "angularx-qrcode";

@NgModule({
	imports: [StagesCommonModule, UserRoutingModule, QRCodeModule],
	declarations: [SudoDialogComponent, UserComponent, UserSettingsComponent, OtpDialogComponent],
})
export class StagesUserModule {}
